import React from 'react';
import ModalImage from "react-modal-image";

const Hardware = () => {
  return(
    <article id="hardware">
      <h1 className="space-left bold">Hardware Setup</h1>
      <section>
        <h2>Beardboard Wiring Diagram</h2>
        <figure id="wiring">
          <ModalImage
            small="./img/hardware/wiring-diagram.png"
            large="./img/hardware/wiring-diagram.png"
            hideDownload={true}
            hideZoom={true}
            showRotate={false}
            alt="Wiring diagram that shows how hardware components are connected to the microcontroller"
          />
          <figcaption className="small-text">
            Designed by Michael Fiscus
          </figcaption>
        </figure>
      </section>
      <section>
        <h2>SmartCrib Prototype on Breadboard</h2>
        <figure id="wiring">
          <ModalImage
            small="./img/hardware/breadboard.png"
            large="./img/hardware/breadboard.png"
            hideDownload={true}
            hideZoom={true}
            showRotate={false}
            alt="Actual breadboard prototype of SmartCrib built according to the wiring diagram"
          />
          <figcaption className="small-text">
            Captured by Parker
          </figcaption>
        </figure>
      </section>
      <section>
        <h2>Adafruit Feather M0 WiFi with ATWINC1500 Pinout Diagram</h2>
        <figure id="board">
          <ModalImage
            small="./img/hardware/pinout.png"
            large="./img/hardware/pinout.png"
            hideDownload={true}
            hideZoom={true}
            showRotate={false}
            alt="Pinout diagram of the Adafruit microcontroller"
          />
          <figcaption className="small-text">
            Image from Adafruit
          </figcaption>
        </figure>
      </section>
      <section id="component">
        <h2>Electronic Components</h2>
        <section>
          <h3>Push Buttons</h3>
          <div className="flex">
            <figure>
              <img src="./img/hardware/button.jpg" alt="Push Buttons" />
              <figcaption className="small-text">
                Image from Sparkfun
              </figcaption>
            </figure>
            <p>
              The 2 push bottons are used to scroll through different screens, displaying
              various data.
            </p>
          </div>
        </section>
        <section>
          <h3>DHT11 Temperature & Humidity Sensor</h3>
          <div className="flex">
            <figure>
              <img src="./img/hardware/dht11.jpg" alt="DHT11 Temperature & Humidity Sensor" />
              <figcaption className="small-text">
                Image from Kookye
              </figcaption>
            </figure>
            <p>
              The temperature and humidity sensor measures the ambient temperature
              and humidity.
            </p>
          </div>
        </section>
        <section>
          <h3>Photosensitive Light Sensor</h3>
            <div className="flex">
              <figure>
                <img src="./img/hardware/light-sensor.jpg" alt="Photosensitive Light Sensor" />
                <figcaption className="small-text">
                  Image from Kookye
                </figcaption>
              </figure>
              <p>
                The photosensitive light sensor is measures the ambient light.
              </p>
            </div>
        </section>
        <section>
          <h3>Sound Detection Sensor</h3>
            <div className="flex">
              <figure>
                <img src="./img/hardware/sound-sensor.jpg" alt="Sound Detection Sensor" />
                <figcaption className="small-text">
                  Image from Kookye
                </figcaption>
              </figure>
              <p>
                The sound detection sensor measures the baby's noise and crying.
              </p>
            </div>
        </section>
        <section>
          <h3>HC-SR501 Infrared Motion Sensor</h3>
            <div className="flex">
              <figure>
                <img src="./img/hardware/motion-sensor.jpg" alt="HC-SR501 Infrared Motion Sensor" />
                <figcaption className="small-text">
                  Image from Kookye
                </figcaption>
              </figure>
              <p>
                The infrared motion detection sensor measures the baby's motion.
              </p>
            </div>
        </section>
        <section>
          <h3>MAX30102 Pulse-Oxygen Rate Sensor</h3>
            <div className="flex">
              <figure>
                <img src="./img/hardware/oximeter.jpg" alt="MAX30102 Pulse & Heart Rate Sensor" />
                <figcaption className="small-text">
                  Image from Amazon
                </figcaption>
              </figure>
              <p>
                The pulse-oxygen sensor collects heart rate.
              </p>
            </div>
        </section>
        <section>
          <h3>MPU-6050 Accelerometer & Gyroscope</h3>
            <div className="flex">
              <figure>
                <img src="./img/hardware/accelerometer.jpg" alt="MPU-6050 Accelerometer & Gyroscope" />
                <figcaption className="small-text">
                  Image from Amazon
                </figcaption>
              </figure>
              <p>
                The accelerometer & gyroscope measures breathing rate.
              </p>
            </div>
        </section>
        <section>
          <h3>Dorhea SSD1360 OLED Display</h3>
            <div className="flex">
              <figure>
                <img src="./img/hardware/display.jpg" alt="SSD1460 OLED Display" />
                <figcaption className="small-text">
                  Image from Amazon
                </figcaption>
              </figure>
              <p>
                The OLED display displays health metrics collected.
              </p>
            </div>
        </section>
      </section>
      <p id="to-top">
        <a href="#hardware"> Back to Top </a>
      </p>
    </article>
  );
}

export default Hardware;
